import clsx from 'clsx';
import { ProductType } from '@headless-workspace/domain/common/client';
import { useProductDetailContext, InnerHTML } from '@headless-workspace/domain/common/client';
import { ProductInfoTabParamsValue } from '@headless-workspace/domain/common/server';
import { PropsWithFontFamily, typographyStyle } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { ProductKitDescription } from './ProductKitDescription';
import { ProductManufacturerDescription } from './ProductManufacturerDescription';
import styles from './product-info-section.module.scss';

type ProductTabsContentProps = PropsWithFontFamily & {
    productInfoTab: ProductInfoTabParamsValue;
};
export const ProductInfoTabsContent: Component<ProductTabsContentProps> = ({ productInfoTab, fontFamily }) => {
    const { productDetails } = useProductDetailContext();
    const selectedSku = productDetails.type !== ProductType.PRODUCT_SET ? productDetails.sku : undefined;

    return (
        <div className={'h-productInfoModalContainer overflow-x-auto p-1 gap-1.25 flex flex-col'}>
            <InnerHTML
                className={clsx(styles.descriptionWrapper, typographyStyle({ fontFamily }))}
                rawHtml={productInfoTab.value}
            />
            {productInfoTab.additionalContents?.map((content) => {
                switch (content.type) {
                    case 'kit':
                        return (
                            <ProductKitDescription fontFamily={fontFamily} key={content.type} info={content.value} />
                        );
                    case 'manufacturer':
                        return (
                            <ProductManufacturerDescription
                                fontFamily={fontFamily}
                                key={content.type}
                                info={content.value}
                                sku={selectedSku}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </div>
    );
};
